import {
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDataTable,
  CPagination,
  CRow,
  CLabel,
  CInputGroup,
  CInputGroupText,
  CInput,
  CTooltip,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getItem, getList } from "../../api/generics";
import { getRoutePath } from "../../routes";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert, successAlert, warningAlert } from "../utils/messages";
import RecordDeleteModal from "./RecordDeleteModal";
import RecordUpdateModal from "./RecordUpdateModal";
import RecordAsyncImage from "./RecordAsyncImage";
import { defaultValueOnUndefined } from "../../utils/fields";
import GeneratedRecord from "../../models/generated-record";
import { getObjectMinioUrl } from "../../minio/urls";
import RecordImportModal from "./RecordImportModal";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { formatUTCDateTime } from "../../utils/dates";
import RecordItemsImportModal from "./RecordItemsImportModal";
import RecordDeleteItemsModal from "./RecordDeleteItemsModal";

const ITEMS_PER_PAGE = 30;

const RecordList = () => {
  const fields = [
    {
      key: "id",
      _classes: ["text-center", "align-middle"],
      label: "id interno #",
    },
    {
      key: "numberingDate",
      _classes: ["text-center", "align-middle"],
      label: "Fecha de Numeración",
    },
    {
      key: "identifier",
      _classes: ["text-center", "align-middle"],
      label: "Identificador",
    },
    {
      key: "importer",
      _classes: ["text-center", "align-middle"],
      label: "Importador",
    },
    {
      key: "totalCustomsValueUsd",
      _classes: ["text-center", "align-middle"],
      label: "Total Valor Aduanas (U$S)",
    },
    {
      key: "modeOfTransport",
      _classes: ["text-center", "align-middle"],
      label: "Medio de Transporte",
      filter: false,
    },
    {
      key: "entryCustoms",
      _classes: ["text-center", "align-middle"],
      label: "Aduana de Ingreso",
      filter: false,
    },
    {
      key: "destinationCustoms",
      _classes: ["text-center", "align-middle"],
      label: "Aduana Destino",
      filter: false,
    },
    {
      key: "qrUrl",
      _classes: ["text-center", "align-middle"],
      label: "QR",
      filter: false,
    },
    {
      key: "actions",
      _classes: ["text-center"],
      label: "Acciones",
      filter: false,
    },
  ];
  const [showUploadItemsModal, setShowUploadItemsModal] = useState(false);
  const [showDeleteItemsModal, setShowDeleteItemsModal] = useState(false);
  const [showRecordEditModal, setShowRecordEditModal] = useState(false);
  const [showRecordDeleteModal, setShowRecordDeleteModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);

  const [record, setRecord] = useState<GeneratedRecord | undefined>(undefined);
  const [search, setSearch] = useState<string>("");

  const [loading, setLoading] = useState(true);
  const [records, setRecords] = useState<GeneratedRecord[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const history = useHistory();

  const getURLParams = () => {
    let urlParams = new URLSearchParams(history.location.search);
    let page = urlParams.get("page")
      ? parseInt(urlParams.get("page") as string)
      : 1;

    if (page <= 0) {
      page = 1;
    }
    let search = urlParams.get("search") ? urlParams.get("search") : "";
    let map = new Map();
    map.set("search", search);
    map.set("page", page);
    return map;
  };

  const fetchRecords = async () => {
    const urlParams = getURLParams();
    const limit = ITEMS_PER_PAGE;
    const offset = ITEMS_PER_PAGE * Number(urlParams.get("page") - 1);
    const recordsStatus = await getList<GeneratedRecord>(
      "/records/",
      limit,
      offset,
      urlParams
    );
    if (recordsStatus.status === SUCCESS) {
      if (recordsStatus.data !== undefined) {
        const count = recordsStatus.data.count;
        const pages = Math.ceil((count ? count : 0) / ITEMS_PER_PAGE);
        setTotalPages(pages);
        setRecords(recordsStatus.data.items);
        setCurrentPage(urlParams.get("page"));
      }
    } else {
      const message = recordsStatus.detail
        ? recordsStatus.detail
        : "Error desconocido";
      warningAlert(message);
    }
    setLoading(false);
  };

  const onPageChange = (page: number) => {
    setLoading(true);
    let urlParams = new URLSearchParams(history.location.search);
    let previousParams = getURLParams();
    urlParams.set(
      "search",
      previousParams.get("search") ? previousParams.get("search") : ""
    );
    urlParams.set("page", page.toString());
    let url = `?${urlParams.toString()}`;
    history.push(url);
  };

  const onUpdateClick = (record: GeneratedRecord) => {
    setRecord(record);
    setShowRecordEditModal(true);
  };

  const onUploadItemsClick = (record: GeneratedRecord) => {
    setRecord(record);
    setShowUploadItemsModal(true);
  };

  const onUploadItemsCancel = () => {
    setRecord(undefined);
    setShowUploadItemsModal(false);
  };

  const onUploadItemsSuccess = () => {
    successAlert(
      "Importaciòn de ITEMS iniciada con exito. Podría demorarse unos minutos!"
    );
    setShowUploadItemsModal(false);
    setRecord(undefined);
    setRecords([]);
    setLoading(true);
    fetchRecords();
  };


  const onDeleteItemsClick = (record: GeneratedRecord) => {
    setRecord(record);
    setShowDeleteItemsModal(true);
  };

  const onDeleteItemsCancel = () => {
    setRecord(undefined);
    setShowDeleteItemsModal(false);
  };

  const onDeleteItemsSuccess = () => {
    successAlert(
      "Eliminación de ITEMS realizada con exito Pue volver a importar los items correctos!"
    );
    setShowDeleteItemsModal(false);
    setRecord(undefined);
    setRecords([]);
    setLoading(true);
    fetchRecords();
  };

  const onDeleteClick = (record: GeneratedRecord) => {
    setRecord(record);
    setShowRecordDeleteModal(true);
  };

  const onRecordEditCancel = () => {
    setRecord(undefined);
    setShowRecordEditModal(false);
  };

  const onRecordEditSuccess = () => {
    successAlert("Datos guardados con éxito!");
    setShowRecordEditModal(false);
    setRecords([]);
    setLoading(true);
    fetchRecords();
  };

  const onRecordDeleteCancel = () => {
    setRecord(undefined);
    setShowRecordDeleteModal(false);
  };

  const onRecordDeleteSuccess = () => {
    successAlert("Registro eliminado con éxito!");
    setShowRecordDeleteModal(false);
    setRecords([]);
    setLoading(true);
    fetchRecords();
  };

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onSearch = () => {
    setLoading(true);
    let urlParams = new URLSearchParams(history.location.search);
    urlParams.set("search", search);
    let url = `?${urlParams.toString()}`;
    history.push(url);
  };

  const onQRDownloadClick = async (record: GeneratedRecord) => {
    const qrState = await getItem<{ url: string }>(
      `/records/${record.id}/qr_url/`
    );

    if (qrState.status !== SUCCESS || qrState.data === undefined) {
      errorAlert("Error al tratar de obtener el QR");
      return;
    }
    window.open(getObjectMinioUrl(qrState.data.url), "_blank");
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  const onImportClick = () => {
    setShowImportModal(true);
  };

  const onImportCancel = () => {
    setShowImportModal(false);
  };

  const onImportSuccess = () => {
    successAlert(
      "Importaciòn iniciada con exito. Podría demorarse unos minutos antes de ver las entradas en la lista!"
    );
    setShowImportModal(false);
  };

  useEffect(() => {
    fetchRecords();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return history.listen((location) => {
      if (location.pathname !== getRoutePath("records")) {
        return;
      }
      fetchRecords();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <>
      <CRow>
        <CCol lg="12">
          <CCard>
            <CCardHeader className="d-flex flex-row mb-3">
              <div className="p-2 ">
                <h3>Registros Generados</h3>
              </div>
              <div className="p-2 ">
                <CButton
                  color="success"
                  className="float-right"
                  onClick={onImportClick}
                >
                  <BsFillPlusCircleFill />
                  &nbsp; NUEVA IMPORTACIÖN DE DATOS
                </CButton>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol>
                  <CLabel
                    className="visually-hidden"
                    htmlFor="autoSizingInputGroup"
                  ></CLabel>
                  <CInputGroup>
                    <CInputGroupText>
                      <i className="fa fa-search"></i>
                    </CInputGroupText>
                    <CInput
                      type="text"
                      placeholder="Busque por Importador, aduana de ingreso o destino"
                      onChange={onSearchChange}
                      value={search}
                      onKeyDown={handleKeyDown}
                    />
                    <CButton
                      type="button"
                      color="primary"
                      variant="outline"
                      onClick={onSearch}
                    >
                      Buscar
                    </CButton>
                  </CInputGroup>
                </CCol>
              </CRow>
              <div>
                <CDataTable
                  noItemsView={<h2 className="text-center">Sin Resultados</h2>}
                  addTableClasses={"table-fixed"}
                  fields={fields}
                  items={records}
                  striped
                  border
                  loading={loading}
                  responsive
                  scopedSlots={{
                    importer: (item: GeneratedRecord) => {
                      return (
                        <td className="text-center align-middle">
                          {defaultValueOnUndefined("-", item.importer)}
                        </td>
                      );
                    },
                    qrUrl: (item: GeneratedRecord) => {
                      return (
                        <td className="text-center align-middle">
                          <RecordAsyncImage record={item} />
                        </td>
                      );
                    },
                    numberingDate: (item: GeneratedRecord) => {
                      return (
                        <td className="text-center align-middle">
                          {item?.numberingDate
                            ? formatUTCDateTime(
                                new Date(item.numberingDate)
                              )
                            : defaultValueOnUndefined(
                                "-",
                                record?.numberingDate
                              )}
                        </td>
                      );
                    },
                    actions: (item: GeneratedRecord) => {
                      const itemsButton = (
                        <CTooltip content={"Importar Items"}>
                          <CButton
                            className="text-white"
                            color="success"
                            onClick={() => {
                              onUploadItemsClick(item);
                            }}
                          >
                            <i className="fa fa-upload"></i>
                          </CButton>
                        </CTooltip>
                      );
                      const deleteButton = (
                        <CTooltip content={"Eliminar Registro"}>
                          <CButton
                            className="text-white"
                            color="danger"
                            onClick={() => {
                              onDeleteClick(item);
                            }}
                          >
                            <i className="fa fa-trash"></i>
                          </CButton>
                        </CTooltip>
                      );
                      const deleteItemsButton = (
                        <CTooltip content={"Eliminar SubItems del Registro"}>
                          <CButton
                            className="text-white"
                            color="warning"
                            onClick={() => {
                              onDeleteItemsClick(item);
                            }}
                          >
                            <i className="fa fa-eraser"></i>
                          </CButton>
                        </CTooltip>
                      );
                      let downloadQRButton = null;

                      if (item.qrImage !== undefined) {
                        downloadQRButton = (
                          <CTooltip content="Código QR">
                            <CButton
                              className="text-white"
                              color="info"
                              onClick={() => {
                                onQRDownloadClick(item);
                              }}
                            >
                              <i className="fa fa-qrcode"></i>
                            </CButton>
                          </CTooltip>
                        );
                      }

                      return (
                        <td className="text-right align-middle">
                          <CButtonGroup>
                            {downloadQRButton}
                            {/*itemsButton*/}
                            {/*deleteItemsButton*/}
                            {deleteButton}
                          </CButtonGroup>
                        </td>
                      );
                    },
                  }}
                />
                <div className="d-flex justify-content-center">
                  <CPagination
                    pages={totalPages}
                    activePage={currentPage}
                    onActivePageChange={(i: number) => onPageChange(i)}
                    className={totalPages < 2 ? "d-none" : ""}
                  />
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <RecordDeleteModal
        show={showRecordDeleteModal}
        onCancel={onRecordDeleteCancel}
        onSuccess={onRecordDeleteSuccess}
        record={record}
      />
      <RecordUpdateModal
        show={showRecordEditModal}
        onCancel={onRecordEditCancel}
        onSuccess={onRecordEditSuccess}
        record={record}
      />
      <RecordImportModal
        show={showImportModal}
        onCancel={onImportCancel}
        onSuccess={onImportSuccess}
      ></RecordImportModal>
      <RecordItemsImportModal
        record={record}
        show={showUploadItemsModal}
        onCancel={onUploadItemsCancel}
        onSuccess={onUploadItemsSuccess}
      ></RecordItemsImportModal>
      <RecordDeleteItemsModal
        record={record}
        show={showDeleteItemsModal}
        onCancel={onDeleteItemsCancel}
        onSuccess={onDeleteItemsSuccess}
      ></RecordDeleteItemsModal>
    </>
  );
};

export default RecordList;
